import {useMemo} from "react";
import {useGetContactInfo} from "../api/initial/useGetContactInfo";
import {useTradablePortfolioSelect} from "../components/TradingModals/useTradablePortfolioSelect";
import {useGetContractIdData} from "../providers/ContractIdProvider";

export const useExtId = (fallBackToFirst = true) => {
    let isFallback = false;
    const {selectedContactId,} = useGetContractIdData();
    const {portfolioId} = useTradablePortfolioSelect();
    const {data: {portfolios} = {portfolios: []}, refetch} = useGetContactInfo(
        false,
        selectedContactId
    );
    let selectedPortfolio = useMemo(() => {
        return portfolios.find((p) => p.id === portfolioId);
    }, [portfolios, portfolioId]);

    if (fallBackToFirst && (!portfolioId || !selectedPortfolio)) {
        selectedPortfolio = portfolios[0];
        isFallback = true;
    }

    const extId = selectedPortfolio?.shortName ? selectedPortfolio?.shortName.split('-')[0] : '';

    return {
        extId,
        selectedContactId,
        portfolioId,
        selectedPortfolio,
        portfolios,
        isFallback,
        refetch
    };
};
